var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.8955C16 11.9564 15.5786 12.9738 14.8284 13.7239C14.0783 14.4741 13.0609 14.8955 12 14.8955C10.9391 14.8955 9.92172 14.4741 9.17157 13.7239C8.42143 12.9738 8 11.9564 8 10.8955M3.103 6.92951H20.897M3.4 6.36251C3.14036 6.7087 3 7.12977 3 7.56251V20.8955C3 21.4259 3.21071 21.9346 3.58579 22.3097C3.96086 22.6848 4.46957 22.8955 5 22.8955H19C19.5304 22.8955 20.0391 22.6848 20.4142 22.3097C20.7893 21.9346 21 21.4259 21 20.8955V7.56251C21 7.12977 20.8596 6.7087 20.6 6.36251L18.6 3.69551C18.4137 3.44712 18.1721 3.24551 17.8944 3.10665C17.6167 2.9678 17.3105 2.89551 17 2.89551H7C6.68951 2.89551 6.38328 2.9678 6.10557 3.10665C5.82786 3.24551 5.58629 3.44712 5.4 3.69551L3.4 6.36251Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.b76c1c849cdab35b1ae1bf677b58c3d4.svg";
export { ForwardRef as ReactComponent };